export default "__VITE_ASSET__e7b9c0cd__"